import React from 'react'
import { useTranslation } from 'react-i18next'
import { GridItem, MuiTypography } from '../../../../components/storybook'
import { formatTime } from '../../functions'

function ProcessingDaysText({ days, t }) {
    if (days === 0) return ` ${t('WARNING_PROCESS_SAME_DAY')}`
    if (days === 1) return <> {t('WARNING_PROCESS_ONE_BUSINESS_DAY')} <strong>{t('WARNING_ONE_BUSINESS_DAY')}</strong></>
    return <> {t('WARNING_PROCESS_BUSINESS_DAYS')} <strong>{days} {t('WARNING_BUSINESS_DAYS')}</strong></>
}

export function Warning({ generalRules, transferInfo }) {
    const { t } = useTranslation()
    const days = generalRules?.daysToProcessTransfer

    return (
        <GridItem xs={12} sm={12} md={12} lg={12} mt={3} sx={{ paddingLeft: '0px !important' }}>
            <MuiTypography color="#AEAEAE" fontSize="14px">
                {t('WARNING_TRANSFER_ALLOWED_PERIOD', {
                    start: formatTime(generalRules?.startTransferPeriod),
                    end: formatTime(generalRules?.endTransferPeriod),
                })}
                {generalRules?.allowDaysToProcessTransfer && <ProcessingDaysText days={days} t={t} />}
                .
            </MuiTypography>
            {generalRules?.allowDailyTransferLimit && (
                <MuiTypography color="#AEAEAE" fontSize="14px">
                    {t('WARNING_DAILY_TRANSFER_LIMIT', { limit: transferInfo?.transferLimitLeft })}
                </MuiTypography>
            )}
        </GridItem>
    )
}
